// src/PlaceIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PlaceIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20.48 20.48",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.24 10.24a3.84 3.84 0 1 0 0 -7.68 3.84 3.84 0 0 0 0 7.68m0 1.28a5.12 5.12 0 1 1 0 -10.24 5.12 5.12 0 0 1 0 10.24"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.24 10.24a0.64 0.64 0 0 1 0.64 0.64v5.12a0.64 0.64 0 1 1 -1.28 0V10.88a0.64 0.64 0 0 1 0.64 -0.64"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.68 12.982v1.299C5.395 14.647 3.84 15.438 3.84 16c0 0.754 2.798 1.92 6.4 1.92s6.4 -1.166 6.4 -1.92c0 -0.563 -1.555 -1.353 -3.84 -1.719v-1.299C15.782 13.421 17.92 14.607 17.92 16c0 1.766 -3.438 3.2 -7.68 3.2s-7.68 -1.434 -7.68 -3.2c0 -1.394 2.138 -2.579 5.12 -3.018"
        }
      )
    ]
  }
);
var PlaceIcon_default = PlaceIcon;

export {
  PlaceIcon_default
};
